import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import { categories } from '@/mocks/categories';
import { featuredVideos } from '@/mocks/videos';
import { getRecentArticles, getPopularArticles } from '@/mocks/articles';

const faqs = [
  {
    question: '69视频是什么？',
    answer: '69视频是一个特色视频网站导航和内容聚合平台，汇集了丝瓜视频、蓝莓视频、糖心视频、黑桃视频、妖精视频、桃花视频等多个优质视频平台，为用户提供一站式视频资源发现和观看服务，涵盖电影、电视剧、综艺、动漫等多种类型的丰富视频内容。',
  },
  {
    question: '在69视频观看视频需要付费吗？',
    answer: '69视频作为视频导航和聚合平台，本身不收取任何费用。各特色视频网站可能有不同的收费模式，但大部分平台都提供免费观看内容。您可以通过69视频快速找到感兴趣的视频资源并跳转至对应平台观看。',
  },
  {
    question: '69视频包含哪些视频类型？',
    answer: '69视频涵盖了丰富的视频类型，包括最新电影、热播电视剧、综艺娱乐、动漫番剧、纪录片、古装武侠、悬疑推理、科幻动作、爱情喜剧、奇幻魔幻等多种类别，满足不同用户群体的观影需求。',
  },
  {
    question: '如何找到我喜欢的视频内容？',
    answer: '您可以通过69视频首页的分类导航快速浏览不同视频平台的内容，也可以使用搜索功能查找特定类型的视频。每个分类页面都提供了详细的标签筛选和热门推荐，帮助您快速发现感兴趣的视频资源。',
  },
  {
    question: '69视频的内容更新频率如何？',
    answer: '69视频每日更新最新的视频资源和影视资讯，各特色视频网站持续更新片库内容，确保用户能够第一时间获取最新上线的视频资源。无论是新片上映还是热门剧集更新，都能在69视频平台上找到。',
  },
];

export default function Home() {
  const recentArticles = getRecentArticles(6);
  const popularArticles = getPopularArticles(4);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '69视频',
    url: 'https://69video.com',
    description: '69视频汇聚丝瓜视频、蓝莓视频、糖心视频、黑桃视频等特色视频网站，提供丰富视频资源免费在线观看。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://69video.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <div className="min-h-screen bg-background-50 text-foreground-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative w-full overflow-hidden">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20background%20with%20warm%20golden%20spotlight%2C%20elegant%20velvet%20curtains%2C%20film%20reel%20texture%2C%20dramatic%20lighting%2C%20premium%20entertainment%20venue%20atmosphere%2C%20rich%20dark%20tones%20with%20amber%20accents&width=1920&height=800&seq=hero-bg-01&orientation=landscape"
                alt="69视频 - 特色视频网站大全"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-background-50"></div>
            </div>
            <div className="relative w-full px-4 md:px-6 lg:px-8 py-24 md:py-36 lg:py-48">
              <div className="max-w-4xl mx-auto text-center">
                <h1 className="text-3xl md:text-5xl lg:text-6xl font-black tracking-tight text-white leading-tight">
                  <span className="text-amber-400">69视频</span> — 特色视频网站大全
                </h1>
                <p className="mt-6 text-base md:text-lg text-gray-300 max-w-2xl mx-auto leading-relaxed">
                  汇聚丝瓜视频、蓝莓视频、糖心视频、黑桃视频等优质视频平台，免费在线观看海量高清影视资源，电影电视剧综艺动漫一网打尽。
                </p>
                <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
                  <Link
                    to="/category/sigua-video"
                    className="w-full sm:w-auto px-8 py-3.5 bg-amber-500 hover:bg-amber-400 text-black font-semibold rounded-lg transition-all text-sm whitespace-nowrap cursor-pointer"
                  >
                    立即探索 <i className="ri-arrow-right-line ml-1"></i>
                  </Link>
                  <Link
                    to="/about"
                    className="w-full sm:w-auto px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white font-medium rounded-lg transition-all text-sm whitespace-nowrap cursor-pointer border border-white/10"
                  >
                    了解更多
                  </Link>
                </div>
              </div>
            </div>
          </section>

          {/* Stats Bar */}
          <section className="w-full px-4 md:px-6 lg:px-8 -mt-10 relative z-10">
            <div className="max-w-5xl mx-auto bg-background-100/90 backdrop-blur-md rounded-xl border border-white/10 p-6 md:p-8">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
                <div>
                  <p className="text-2xl md:text-3xl font-bold text-amber-400 font-heading">12,000+</p>
                  <p className="text-xs md:text-sm text-gray-400 mt-1">视频资源</p>
                </div>
                <div>
                  <p className="text-2xl md:text-3xl font-bold text-amber-400 font-heading">6</p>
                  <p className="text-xs md:text-sm text-gray-400 mt-1">特色视频网站</p>
                </div>
                <div>
                  <p className="text-2xl md:text-3xl font-bold text-amber-400 font-heading">500+</p>
                  <p className="text-xs md:text-sm text-gray-400 mt-1">每日更新</p>
                </div>
                <div>
                  <p className="text-2xl md:text-3xl font-bold text-amber-400 font-heading">98%</p>
                  <p className="text-xs md:text-sm text-gray-400 mt-1">用户好评</p>
                </div>
              </div>
            </div>
          </section>

          {/* Category Grid */}
          <section className="w-full px-4 md:px-6 lg:px-8 py-16 md:py-20">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="text-2xl md:text-3xl font-bold text-white">
                  特色<span className="text-amber-400">视频网站</span>
                </h2>
                <p className="mt-3 text-sm text-gray-400 max-w-lg mx-auto">
                  六大特色视频平台，覆盖电影、电视剧、综艺、动漫等多种类型，满足您的观影需求
                </p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {categories.map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className="group relative bg-background-100 rounded-xl overflow-hidden border border-white/5 hover:border-white/15 transition-all duration-300 cursor-pointer"
                  >
                    <div className="aspect-[16/9] overflow-hidden">
                      <img
                        src={cat.featuredImage}
                        alt={`${cat.name} - 69视频特色视频网站`}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-transparent to-transparent"></div>
                    </div>
                    <div className="p-5">
                      <div className="flex items-center gap-3 mb-2">
                        <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${cat.color}20` }}>
                          <i className={`${cat.icon} text-lg`} style={{ color: cat.color }}></i>
                        </div>
                        <h3 className="text-lg font-bold text-white group-hover:text-amber-400 transition-colors">{cat.name}</h3>
                      </div>
                      <p className="text-sm text-gray-400 line-clamp-2 leading-relaxed">{cat.description}</p>
                      <div className="mt-4 flex items-center gap-3 text-xs text-gray-500">
                        <span><i className="ri-play-circle-line mr-1"></i>{cat.videoCount.toLocaleString()} 部视频</span>
                        <span><i className="ri-article-line mr-1"></i>{cat.articleCount} 篇文章</span>
                      </div>
                      <div className="mt-3 flex flex-wrap gap-1.5">
                        {cat.tags.slice(0, 3).map((tag, i) => (
                          <span key={i} className="px-2 py-0.5 text-xs rounded-md bg-white/5 text-gray-400">{tag}</span>
                        ))}
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* Featured Videos */}
          <section className="w-full px-4 md:px-6 lg:px-8 py-16 md:py-20 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-end justify-between mb-10">
                <div>
                  <h2 className="text-2xl md:text-3xl font-bold text-white">
                    精选<span className="text-amber-400">推荐</span>
                  </h2>
                  <p className="mt-2 text-sm text-gray-400">编辑精选的高分影视作品，不容错过</p>
                </div>
                <Link to="/category/sigua-video" className="hidden sm:flex items-center gap-1 text-sm text-amber-400 hover:text-amber-300 transition-colors whitespace-nowrap">
                  查看全部 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {featuredVideos.map((video) => (
                  <Link
                    key={video.id}
                    to={`/category/${categories.find(c => c.id === video.categoryId)?.slug || ''}`}
                    className="group bg-background-50 rounded-xl overflow-hidden border border-white/5 hover:border-white/10 transition-all cursor-pointer"
                  >
                    <div className="aspect-[16/10] overflow-hidden relative">
                      <img
                        src={video.coverImage}
                        alt={video.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                      <div className="absolute top-3 left-3">
                        <span className="px-2 py-1 text-xs font-semibold rounded-md bg-amber-500 text-black">{video.rating}</span>
                      </div>
                      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                        <div className="w-12 h-12 rounded-full bg-amber-500/90 flex items-center justify-center">
                          <i className="ri-play-fill text-white text-xl ml-0.5"></i>
                        </div>
                      </div>
                    </div>
                    <div className="p-4">
                      <h3 className="font-semibold text-white text-sm group-hover:text-amber-400 transition-colors line-clamp-1">{video.title}</h3>
                      <p className="text-xs text-gray-500 mt-1 line-clamp-2">{video.description}</p>
                      <div className="mt-3 flex items-center gap-2 text-xs text-gray-500">
                        <span>{video.year}</span>
                        <span className="text-gray-700">·</span>
                        <span>{video.duration}</span>
                        <span className="text-gray-700">·</span>
                        <span className="text-amber-400/80">{video.categoryName}</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
              <div className="mt-8 text-center sm:hidden">
                <Link to="/category/sigua-video" className="inline-flex items-center gap-1 text-sm text-amber-400 hover:text-amber-300 transition-colors">
                  查看全部 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </section>

          {/* Latest Articles */}
          <section className="w-full px-4 md:px-6 lg:px-8 py-16 md:py-20">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="text-2xl md:text-3xl font-bold text-white">
                  最新<span className="text-amber-400">影视资讯</span>
                </h2>
                <p className="mt-3 text-sm text-gray-400 max-w-lg mx-auto">
                  影视行业动态、新片推荐、观影指南，一手掌握最新影视资讯
                </p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {recentArticles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.slug}`}
                    className="group bg-background-100 rounded-xl overflow-hidden border border-white/5 hover:border-white/10 transition-all cursor-pointer"
                  >
                    <div className="aspect-[16/9] overflow-hidden">
                      <img
                        src={article.coverImage}
                        alt={article.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-5">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="px-2 py-0.5 text-xs rounded-md bg-amber-400/10 text-amber-400">{article.categoryName}</span>
                        <span className="text-xs text-gray-600">{article.readTime} 分钟阅读</span>
                      </div>
                      <h3 className="font-semibold text-white text-base group-hover:text-amber-400 transition-colors line-clamp-2 leading-snug">{article.title}</h3>
                      <p className="text-sm text-gray-400 mt-2 line-clamp-2">{article.excerpt}</p>
                      <div className="mt-4 flex items-center justify-between text-xs text-gray-600">
                        <span>{article.publishDate}</span>
                        <span><i className="ri-eye-line mr-1"></i>{article.viewCount.toLocaleString()}</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* Why Choose Us */}
          <section className="w-full px-4 md:px-6 lg:px-8 py-16 md:py-20 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="text-2xl md:text-3xl font-bold text-white">
                  为什么选择<span className="text-amber-400">69视频</span>？
                </h2>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                <div className="bg-background-50 rounded-xl p-6 border border-white/5 text-center">
                  <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-amber-400/10 flex items-center justify-center">
                    <i className="ri-movie-2-line text-2xl text-amber-400"></i>
                  </div>
                  <h3 className="font-semibold text-white mb-2">资源丰富</h3>
                  <p className="text-sm text-gray-400">汇聚六大特色视频平台，超过12000部视频资源，涵盖多种类型</p>
                </div>
                <div className="bg-background-50 rounded-xl p-6 border border-white/5 text-center">
                  <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-amber-400/10 flex items-center justify-center">
                    <i className="ri-4k-line text-2xl text-amber-400"></i>
                  </div>
                  <h3 className="font-semibold text-white mb-2">高清画质</h3>
                  <p className="text-sm text-gray-400">支持4K超清画质播放，畅享影院级观影体验，流畅不卡顿</p>
                </div>
                <div className="bg-background-50 rounded-xl p-6 border border-white/5 text-center">
                  <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-amber-400/10 flex items-center justify-center">
                    <i className="ri-shield-check-line text-2xl text-amber-400"></i>
                  </div>
                  <h3 className="font-semibold text-white mb-2">安全可靠</h3>
                  <p className="text-sm text-gray-400">所有视频来源经过审核，保障观看安全，让您放心观影</p>
                </div>
                <div className="bg-background-50 rounded-xl p-6 border border-white/5 text-center">
                  <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-amber-400/10 flex items-center justify-center">
                    <i className="ri-flashlight-line text-2xl text-amber-400"></i>
                  </div>
                  <h3 className="font-semibold text-white mb-2">实时更新</h3>
                  <p className="text-sm text-gray-400">每日更新最新视频资源，第一时间为您推送热门影片和剧集</p>
                </div>
              </div>
            </div>
          </section>

          {/* Popular Articles Sidebar Style */}
          <section className="w-full px-4 md:px-6 lg:px-8 py-16 md:py-20">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                <div className="lg:col-span-2">
                  <h2 className="text-2xl md:text-3xl font-bold text-white mb-8">
                    热门<span className="text-amber-400">推荐</span>
                  </h2>
                  <div className="space-y-4">
                    {popularArticles.map((article) => (
                      <Link
                        key={article.id}
                        to={`/article/${article.slug}`}
                        className="flex flex-col sm:flex-row gap-4 bg-background-100 rounded-xl p-4 border border-white/5 hover:border-white/10 transition-all cursor-pointer group"
                      >
                        <div className="w-full sm:w-48 h-28 rounded-lg overflow-hidden flex-shrink-0">
                          <img
                            src={article.coverImage}
                            alt={article.title}
                            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                            loading="lazy"
                          />
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 mb-1">
                            <span className="px-2 py-0.5 text-xs rounded-md bg-amber-400/10 text-amber-400">{article.categoryName}</span>
                          </div>
                          <h3 className="font-semibold text-white group-hover:text-amber-400 transition-colors line-clamp-1">{article.title}</h3>
                          <p className="text-sm text-gray-400 mt-1 line-clamp-2">{article.excerpt}</p>
                          <div className="mt-3 flex items-center gap-4 text-xs text-gray-600">
                            <span><i className="ri-eye-line mr-1"></i>{article.viewCount.toLocaleString()} 阅读</span>
                            <span><i className="ri-heart-line mr-1"></i>{article.likeCount.toLocaleString()} 点赞</span>
                            <span>{article.publishDate}</span>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
                <div>
                  <div className="bg-background-100 rounded-xl p-6 border border-white/5 sticky top-24">
                    <h3 className="font-semibold text-white mb-4">视频分类标签</h3>
                    <div className="flex flex-wrap gap-2">
                      {categories.flatMap(cat => cat.tags).filter((v, i, a) => a.indexOf(v) === i).slice(0, 12).map((tag, i) => (
                        <span key={i} className="px-3 py-1.5 text-xs rounded-lg bg-white/5 text-gray-300 hover:bg-amber-400/10 hover:text-amber-400 transition-colors cursor-pointer">{tag}</span>
                      ))}
                    </div>
                    <div className="mt-6 pt-6 border-t border-white/5">
                      <h3 className="font-semibold text-white mb-3">关注我们</h3>
                      <div className="flex gap-3">
                        <a href="#" className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/10 transition-colors cursor-pointer"><i className="ri-weibo-line"></i></a>
                        <a href="#" className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/10 transition-colors cursor-pointer"><i className="ri-wechat-line"></i></a>
                        <a href="#" className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/10 transition-colors cursor-pointer"><i className="ri-bilibili-line"></i></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* FAQ Section */}
          <section className="w-full px-4 md:px-6 lg:px-8 py-16 md:py-20 bg-background-100">
            <div className="max-w-3xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="text-2xl md:text-3xl font-bold text-white">
                  常见<span className="text-amber-400">问题</span>
                </h2>
              </div>
              <div className="space-y-3">
                {faqs.map((faq, i) => (
                  <details key={i} className="group bg-background-50 rounded-xl border border-white/5 overflow-hidden">
                    <summary className="flex items-center justify-between px-6 py-4 cursor-pointer text-white font-medium text-sm hover:text-amber-400 transition-colors list-none">
                      {faq.question}
                      <i className="ri-arrow-down-s-line text-gray-400 group-open:rotate-180 transition-transform"></i>
                    </summary>
                    <div className="px-6 pb-4 text-sm text-gray-400 leading-relaxed">
                      {faq.answer}
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>

          {/* CTA */}
          <section className="w-full px-4 md:px-6 lg:px-8 py-16 md:py-20">
            <div className="max-w-4xl mx-auto text-center relative overflow-hidden rounded-2xl bg-background-100 border border-white/5 p-10 md:p-16">
              <div className="absolute inset-0 opacity-10">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20film%20strip%20pattern%2C%20dark%20background%20with%20golden%20light%20streaks%2C%20movie%20themed%20texture%2C%20warm%20amber%20accents%2C%20premium%20entertainment%20aesthetic&width=1200&height=400&seq=cta-bg-01&orientation=landscape"
                  alt=""
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="relative z-10">
                <h2 className="text-2xl md:text-3xl font-bold text-white">准备好探索精彩视频世界了吗？</h2>
                <p className="mt-4 text-sm text-gray-400 max-w-lg mx-auto">
                  立即加入69视频，发现丝瓜视频、蓝莓视频、糖心视频、黑桃视频等特色视频网站的精彩内容，开启您的极致观影体验。
                </p>
                <Link
                  to="/category/sigua-video"
                  className="mt-8 inline-flex items-center gap-2 px-8 py-3.5 bg-amber-500 hover:bg-amber-400 text-black font-semibold rounded-lg transition-all text-sm whitespace-nowrap cursor-pointer"
                >
                  立即探索 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}